module.exports = __webpack_public_path__ + "media/index/cnn-cfe9d5cb.svg";